<script setup lang="ts">
import { onMounted, ref } from 'vue'
import ModalFormTemplate from '../../../../../components/ui/Templates/ModalFormTemplate.vue';
import SearchSelect from '../../../../../components/ui/form/SearchSelect.vue';
import { useFormValidation } from '../../../../../composables/useFormValidation';
import { required } from '../../../../../utils/validation';
import { api } from '../../../../../api/Api';
import Toast from '../../../../../services/Toast';
import TextInput from '../../../../../components/ui/form/TextInput.vue';
import { tokenManager } from '../../../../../api/utils/tokenManager';



const title = 'Register POS Station'
const endPoint = 'system/company/outlets/'

const isReadOnly = ref(false)
defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm } = useFormValidation({
  outlets_id: '',
  pos_stations_id: '',
  otp: '',
  device_name: '',
})

setFieldRules('outlets_id', [required('Outlet is required')])
setFieldRules('pos_stations_id', [required('POS Station is required')])
setFieldRules('otp', [required('OTP is required')])


function generateUniqueToken():string {
    const browserInfo = getBrowserInfo();
    const deviceMemory = 'unknown';
    const hardwareConcurrency = navigator.hardwareConcurrency || 'unknown';
    const userAgent = navigator.userAgent || '';
    const canvasFingerprint = getCanvasFingerprint();
    const timestamp = new Date().toISOString();

    return hashString(
      `${browserInfo}-${deviceMemory}-${hardwareConcurrency}-${userAgent}-${canvasFingerprint}-${timestamp}`
    );
  }

  function getBrowserInfo() {
    const { appName, appVersion, platform, product } = navigator;
    return `${appName}-${appVersion}-${platform}-${product}`;
  }

  function getCanvasFingerprint() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.textBaseline = 'top';
      ctx.font = '16px Arial';
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f60';
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = '#069';
      ctx.fillText('Browser unique token', 2, 15);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
      ctx.fillText('Browser unique token', 4, 17);
      return canvas.toDataURL();
    }
    return '';
  }

  function hashString(str: string) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // Convert to 32bit integer
    }
    return hash.toString();
  }

const handleSubmit = async () => {
  formData.value.device_name = generateUniqueToken()
  if (validateForm()) {
    const response = await api.post((endPoint.slice(-1) == '/' ? endPoint : endPoint + '/') + 'register-pos-station', formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      tokenManager.setPosStation(response.data)
      window.location.reload()
    }
  }
}

onMounted(() => {
  console.log('mounted')
  resetForm()
})


</script>
<template>
  <ModalFormTemplate mode="create" :title="title" :endPoint="endPoint"
     :tabList="[]" :formData="formData" @save="handleSubmit" :ignore-permission="true"
    @close="$emit('close')" save-close-caption="Register" save-close-icon="MonitorCog">
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">

        <SearchSelect v-model="fields.outlets_id.value" label="Outlet" end-point="system/company/outlets"
          :readonly="isReadOnly" :error="fields.outlets_id.touched ? fields.outlets_id.error : null"
          @blur="fields.outlets_id.touched = true" />

        <SearchSelect v-model="fields.pos_stations_id.value" label="POS Station" custom-url="system/company/outlets/pos-stations"
          :readonly="isReadOnly" :error="fields.pos_stations_id.touched ? fields.pos_stations_id.error : null"
          @blur="fields.pos_stations_id.touched = true" :extra="fields.outlets_id.value" />

          <TextInput v-model="fields.otp.value" label="OTP" placeholder="Enter OTP" :readonly="isReadOnly"
          :error="fields.otp.touched ? fields.otp.error : null" @blur="fields.otp.touched = true" />


      </div>
    </template>
  </ModalFormTemplate>
</template>